import {
  GETALL_UNIVERSITY_FAIL,
  GETALL_UNIVERSITY_SUCCESS,
  GETALL_UNIVERSITY_REQUEST,
  DELETE_UNIVERSITY_SUCCESS,
  DELETE_UNIVERSITY_REQUEST,
  DELETE_UNIVERSITY_FAIL,
  UPDATE_UNIVERSITY_SUCCESS,
  UPDATE_UNIVERSITY_FAIL,
  UPDATE_UNIVERSITY_REQUEST,
  ADD_UNIVERSITY_FAIL,
  ADD_UNIVERSITY_SUCCESS,
  ADD_UNIVERSITY_REQUEST,
  GET_UNIVERSITY_FAIL,
  GET_UNIVERSITY_SUCCESS,
  GET_UNIVERSITY_REQUEST,
  CLEAR_UNIVERSITY_RECORD,
} from "../constant/UniversityConstant";

const initialState = {
  loading: false,
  action: "University",
  result: [],
  success: false,
  singledata: [],
  message: "",
  error: "",
};

const UniversityReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_UNIVERSITY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GETALL_UNIVERSITY_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload.data.list,
        pageNumber: action.payload.data.pageNumber,
        totalCount: action.payload.data.totalCount,
        pageCount: action.payload.data.pageCount,
        message: action.message,
      };
    case GETALL_UNIVERSITY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };

    case GET_UNIVERSITY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_UNIVERSITY_SUCCESS:
      return {
        ...state,
        loading: false,
        singledata: action.payload.data,
        message: action.message,
      };
    case GET_UNIVERSITY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };

    case ADD_UNIVERSITY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_UNIVERSITY_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.filter((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        message: action.message,
      };
    case ADD_UNIVERSITY_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
        message: action.message,
      };

    case UPDATE_UNIVERSITY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_UNIVERSITY_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.map((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),

        message: action.message,
      };
    case UPDATE_UNIVERSITY_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
        message: action.message,
      };

    case DELETE_UNIVERSITY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_UNIVERSITY_SUCCESS:
      return {
        ...state,
        loading: false,
        result: state.result.filter((item) => item.id !== action.payload.id),
        message: action.message,
      };
    case DELETE_UNIVERSITY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: action.message,
      };
    case CLEAR_UNIVERSITY_RECORD:
      return {
        ...state,
        loading: false,
        result: [],
        singledata: [],
        message: action.message,
      };

    default:
      return state;
  }
};

export default UniversityReducer;
